import { render, staticRenderFns } from "./SfBadge.vue?vue&type=template&id=02ac5510&functional=true&"
import script from "./SfBadge.vue?vue&type=script&lang=ts&"
export * from "./SfBadge.vue?vue&type=script&lang=ts&"
import style0 from "./SfBadge.vue?vue&type=style&index=0&id=02ac5510&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports